import React from 'react';
import { Box, Switch, Typography } from '@mui/material';

/**
 * On/Off switch for an Elliott lesson section (Case Studies / Live Simulation).
 * Purely presentational — the parent persists the flag.
 */
const SectionToggle: React.FC<{
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  /** Hover tooltip; defaults to a generic section on/off hint. */
  title?: string;
  /** The switch's accessible name, e.g. "Roleplay" (a lesson shows one per section). */
  label?: string;
}> = ({ enabled, onToggle, title = 'Turn this section on or off for this lesson', label }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }} title={title}>
    <Switch
      size="small"
      checked={enabled}
      onChange={(e) => onToggle(e.target.checked)}
      inputProps={{ 'aria-label': label ?? title }}
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--Stroke-highlight, #F79420)' },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: 'var(--Stroke-highlight, #F79420)'
        },
        '& .MuiSwitch-track': { backgroundColor: 'var(--Text-text-tertiary, #868686)' }
      }}
    />
    <Typography
      sx={{
        fontSize: 12,
        fontFamily: 'Inter',
        fontWeight: 600,
        minWidth: 22,
        color: enabled ? 'var(--Stroke-highlight, #F79420)' : 'var(--Text-text-tertiary, #868686)'
      }}
    >
      {enabled ? 'On' : 'Off'}
    </Typography>
  </Box>
);

export default SectionToggle;
